<template>
  <div>
    <a-card>
      <a-descriptions title="基本信息">
        <a-descriptions-item label="企业ID">
          {{ baseInfo.code }}
        </a-descriptions-item>
        <a-descriptions-item label="企业名称">
          {{ baseInfo.name }}
        </a-descriptions-item>
        <a-descriptions-item label="担保类型">
          {{ type === '2' ? '担保-保证书' : '' }}
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    //这里存放数据
    return {
      companyCode: '',
    }
  },
  components: {},
  props: {
    baseInfo: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
    },
  },
  //方法集合
  methods: {},
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
